import { BREADCRUMBS } from 'breadcrumbs/constants/breadcrumbs';
import { getCategoryPageServerSideProps } from 'server/utils/getCategoryPageServerSideProps';
import { IProductLandingPage } from 'shared/types/ProductLandingPage';
import { PlpPageComponent as PLPLandingPageComponent } from 'product-landing-pages/components/PlpPageComponent';
import { isSearchCrawler } from 'shared/utils/isSearchCrawler';
import { setServerSideTranslations } from 'localization/utils/setServerSideTranslations';

const BagsPage = ({
  breadcrumbs,
  browseKey,
  browseValue,
  constructorResponse,
  displayName,
  globalPricingId,
  isCrawler = false,
  consumerSearchFilters = {},
  consumerSearchInitialData = '{}',
}: IProductLandingPage) => {
  const {
    name = displayName,
    description = '',
    metadataDescription = '',
    titleTag = '',
  } = breadcrumbs || {};

  return (
    <PLPLandingPageComponent
      browseKey={browseKey}
      browseValue={browseValue}
      constructorResponse={constructorResponse}
      description={description}
      displayName={name}
      globalPricingId={globalPricingId}
      metadataDescription={metadataDescription}
      metaTitle={titleTag}
      isCrawler={isCrawler}
      consumerSearchFilters={consumerSearchFilters}
      consumerSearchInitialData={JSON.parse(consumerSearchInitialData)}
    />
  );
};

export const getServerSideProps = async ({ query, resolvedUrl, req, res, locale }) => {
  const category = BREADCRUMBS.BAGS;
  const isCrawler = isSearchCrawler(req?.headers);
  const i18n = await setServerSideTranslations({ locale });
  const categoryProps = await getCategoryPageServerSideProps({
    category,
    query,
    resolvedUrl,
    req,
    res,
    isCrawler,
    i18n,
  });
  return categoryProps;
};

export default BagsPage;
